/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Provisioning_Partner_Code_Not_Applicable_For_PlanInputs */

const es_co2_error_provisioning_partner_code_not_applicable_for_plan = /** @type {(inputs: Error_Provisioning_Partner_Code_Not_Applicable_For_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El destino solo aplica al plan con llave de aliado.`)
};

/**

* @param {Error_Provisioning_Partner_Code_Not_Applicable_For_PlanInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_provisioning_partner_code_not_applicable_for_plan = /** @type {((inputs?: Error_Provisioning_Partner_Code_Not_Applicable_For_PlanInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Provisioning_Partner_Code_Not_Applicable_For_PlanInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_provisioning_partner_code_not_applicable_for_plan(inputs)
});